export default [
    {
        path: 'overview',
        name: 'Overview',
        redirect : "helloworld",
    },
    {
        path: 'helloworld',
        name: 'Hello World',
        component: () => import( /* webpackChunkName: "my-app-helloworld" */ '../views/HelloWorld.vue'),
        meta: {
            mainNavEnabled: true,
        },
    },
    {
        path: 'todolist',
        name: 'Todo List',
        component: () => import( /* webpackChunkName: "my-app-todolist" */ '../views/TodoList.vue'),
        meta: {
            mainNavEnabled: true,
        },
    },
    {
        path: 'configuration',
        name: 'Configuration',
        component: () => import( /* webpackChunkName: "my-app-helloworld" */ '../views/Configuration.vue'),
        meta: {
            mainNavEnabled: true,
        },
    },
]
